import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {MenuExternal, MenuItem} from '../menu-config/menu-item';

@Component({
    selector: 'li[app-menu-item]',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    standalone: false
})
export class MenuItemComponent
{
    @Input() item!: MenuItem;
    @Input() signUpFeePaid: boolean = true;
    @Input() openGroupKey: string | null = null;
    @Output() linkClick = new EventEmitter<void>();
    @Output() externalClick = new EventEmitter<MenuExternal>();
    @Output() groupToggle = new EventEmitter<string>();

    @HostBinding('class.dropdown')
    get isGroupHost(): boolean
    {
        return this.item?.kind === 'group';
    }

    isCollapsed(collapseKey: string): boolean
    {
        return this.openGroupKey !== collapseKey;
    }

    iconSizeClasses(icon: string | undefined): string
    {
        return icon?.startsWith('pi') ? 'pi-lg pi-fw' : 'fa-lg fa-fw';
    }
}
